export default __webpack_public_path__ + "static/media/553.d2de6fac.png";